export default {
  请输入: "Please input ",
  预约信息: "Appointment Infomation",
  查看购物车: "View cart",
  订单确认: "Confirm of order",
  home: "Home",
  components: "Components",
  count_to_page: "Count-to",
  tables_page: "Table",
  split_pane_page: "Split-pane",
  markdown_page: "Markdown-editor",
  editor_page: "Rich-Text-Editor",
  icons_page: "Custom-icon",
  img_cropper_page: "Image-editor",
  update: "Update",
  doc: "Document",
  join_page: "QQ Group",
  update_table_page: "Update .CSV",
  update_paste_page: "Paste Table Data",
  multilevel: "multilevel",
  directive_page: "Directive",
  level_1: "Level-1",
  level_2: "Level-2",
  level_2_1: "Level-2-1",
  level_2_3: "Level-2-3",
  level_2_2: "Level-2-2",
  level_2_2_1: "Level-2-2-1",
  level_2_2_2: "Level-2-2-2",
  excel: "Excel",
  "upload-excel": "Upload Excel",
  "export-excel": "Export Excel",
  tools_methods_page: "Tools Methods",
  drag_list_page: "Drag-list",
  i18n_page: "Internationalization",
  modalTitle: "Modal Title",
  content: "This is the modal box content.",
  buttonText: "Show Modal",
  "i18n-tip":
    "Note: Only this page is multi-language, other pages do not add language content to the multi-language package.",
  error_store_page: "Error Collection",
  error_logger_page: "Error Logger",
  query: "Query",
  params: "Params",
  cropper_page: "Cropper",
  message_page: "Message Center",
  tree_table_page: "Tree Table",
  注册: "Register",
  登录: "Log In",
  第三方登录: "Third party log In",
  全部商品: "All products",
  "加载中...": "Loading...",
  商品分类: "Product category",
  推荐商品: "Recommend",
  查看更多: "view more",
  "Read More": "Read More",
  商城资讯: "Mall Information ",
  更多: "More",
  综合排序: "comprehensive sort",
  价格从低到高: "price from low to high",
  价格从高到低: "price from high to low",
  价格: "price",
  确定: "Ok",
  "抱歉！暂时还没有商品": "Sorry! there are no products available yet",
  "抱歉！出错了...": "sorry! there was an error...",
  数量: "Quantity",
  加入购物车: "Add to cart",
  加入心愿单: "Add to wish",
  现在购买: "Buy now",
  产品信息: "product information",
  该商品暂无内容数据: "there is no content data for this product at this time",
  账号: "account",
  账户登录: "Log In",
  记住密码: "remember password",
  找回密码: "retrieve password",
  忘记密码: "Forgot password",
  返回: "Return",
  "登录中...": "login in progress...",
  "账号或者密码不能为空!": "account or password cannot be empty!",
  注册账号: "register account",
  登录账号: "login account",
  账号格式不正确: "account format is incorrect",
  手机号: "mobile",
  验证码: "captcha",
  获取验证码: "get captcha",
  重新发送: "resend",
  密码: "password",
  重复密码: "repeat password",
  我已阅读并同意遵守: "I have read and agree to abide by",
  法律声明: "legal notice",
  和: "and",
  隐私条款: "Privacy Policy",
  "如果您已拥有账号，则可在此": "if you already have an account here",
  登陆: "login",
  邮箱: "email",
  "注册中...": "registration in progress...",
  "账号密码不能为空!": "account password cannot be empty!",
  "手机号码验证码不能为空!":
    "mobile phone number verification code cannot be empty!",
  "验证码不能为空!": "verification code cannot be empty!",
  "两次输入的密码不相同!": "the password entered twice is not the same!",
  "您未勾选同意我们的相关注册协议!":
    "you have not checked the box to agree to our relevant registration agreement! ",
  "恭喜您，注册成功！赶紧体验吧":
    "congratulations, your registration was successful! hurry up and experience it",
  "手机号码格式不正确!": "the cell phone number is not in the correct format!",
  验证码已发送: "verification code has been sent",
  公告列表: "announcement list",
  公告详情: "announcement details",
  首页: "Home",
  分类: "Categorys",
  搜索: "Search",
  预约服务: "Appointment service",
  搜索结果: "search results",
  "拼命搜索中...": "desperately searching in...",
  共为您找到: "total found for you",
  款商品信息: "section product information",
  "抱歉！没有为您找到相关的商品":
    "sorry! no related products were found for you",
  我的优惠券: "My coupons",
  添加收货地址: "add shipping address",
  姓名: "Name",
  详细地址: "address details",
  电话: "phone",
  默认地址: "default address",
  你还未添加收货地址: "you haven't added a shipping address yet",
  添加地址: "add address",
  您目前还没有优惠券: "you don't currently have a coupon",
  我的订单: "My orders",
  商品操作: "Product actions",
  实付金额: "Actual amount paid",
  查看详情: "View details",
  你还未创建过订单: "you have not created an order yet",
  支付审核中: "payment review in progress",
  待发货: "Pending shipping",
  待收货: "Pending receipt",
  支付失败: "payment failed",
  付款: "Payment",
  配货: "allocation",
  出库: "outbound",
  订单状态: "Order status",
  取消订单: "Cancel order",
  您的付款时间还有: "your payment time is still available",
  "超时后订单将自动取消。":
    "the order will be automatically cancelled after the timeout.",
  已结束: "closed",
  "订单状态：已支付，待系统审核确认":
    "order status: paid, pending system audit confirmation",
  "订单状态：已关闭": "order status: closed",
  "您的订单已关闭。": "your order has been closed.",
  "订单状态：已完成": "order status: completed",
  "您的订单已交易成功，感谢您的惠顾！":
    "your order has been successfully transacted, thank you for your patronage!",
  商品名称: "Product name",
  "应付金额：": "Amount due:",
  获取该订单信息失败: "failed to get this order information",
  取消失败: "failed to cancel",
  请在: "please cancel within",
  "24 小时内": "within 24 hours",
  "完成支付，超时订单将自动取消。":
    "complete payment, after that time the order will be automatically cancelled.",
  "昵称：": "nickname",
  请输入您的昵称: "please enter your nickname",
  请选择支付金额: "please choose the payment amount",
  "输入金额：": "enter the amount:",
  请输入您的留言内容: "please enter your message content",
  支付方式: "Payment method",
  "订单金额：": "order amount:",
  "实际应付金额：": "actual amount due:",
  "支付中...": "payment in progress...",
  其它: "other",
  立刻支付: "pay now",
  支付成功: "payment successful",
  "总共花费 ": "total cost",
  " 元": " yuan",
  查看订单: "View order",
  继续选购: "continue shopping",
  "收货人: ": "consignee:",
  "(默认地址)": "(default address)",
  "收货地址:": "receiving address:",
  "手机号码: ": "mobile number:",
  新增: "Add",
  修改: "Edit",
  删除: "Delete",
  使用新地址: "Use new address",
  收货人姓名: "recipient name",
  手机号码: "mobile number",
  收货地址: "Receiving address",
  设为默认: "set as default",
  保存: "Save",
  管理收货地址: "manage shipping address",
  "提交订单中...": "submitting order in progress...",
  请选择收货地址: "please select a shipping address",
  非法操作: "illegal operation",
  新增收货地址: "Add shipping address",
  口味: "flavor",
  操作: "Operation",
  全选: "Select all",
  删除选中的商品: "delete selected products",
  已选择: "selected",
  共计: "total",
  件商品: "pieces of products",
  应付总额不含运费: "total amount due without shipping",
  你的购物车空空如也: "Your cart is empty",
  现在选购: "shop now",
  现在结算: "checkout now",
  缺少所需参数: "missing required parameters",
  "结算中...": "checkout in progress...",
  删除失败: "delete failed",
  删除成功: "delete successfully",
  收货信息: "Receiving information",
  商品信息: "Product information",
  购物清单: "Shopping list",
  小计: "subtotal",
  单价: "Single price",
  备注: "remarks",
  请填写备注信息: "please fill in the remarks information",
  使用优惠券: "Use coupon",
  商品总价: "Total price of the products",
  优惠金额: "discount amount",
  运费: "Shipping cost",
  应付总额: "total amount payable",
  可用优惠券: "available coupons",
  折: "Discount",
  满: "Full",
  减: "minus",
  分: "point",
  可用: "Available",
  无限制使用: "Unlimited usage",
  至: "to",
  限商品: "Limited commodities",
  全商品可用: "all products available",
  部分商品可用: "Selected products only",
  限商家: "merchant only",
  全商家可用: "available for all merchants",
  部分商家可用: "partial merchant available",
  立即使用: "Use Now",
  提交订单: "Submit order",
  操作成功: "Operation successful",
  "确定要删除吗？": "are you sure you want to delete?",
  提示: "Tip",
  取消: "Cancel",
  未使用: "Unused",
  已使用: "Used",
  已过期: "Expired",
  共: "total",
  合计: "Total",
  去购物车: "Go to cart",
  您的购物车竟然是空的: "your cart is surprisingly empty",
  个人中心: "personal center",
  退出: "Log out",
  请输入商品信息: "please enter product information",
  全部: "All",
  待付款: "Awaiting for Payment",
  评价: "Rating",
  订单号: "order number",
  查看物流: "view logistics",
  删除订单: "delete order",
  现在付款: "pay now",
  批量评价: "bulk evaluation",
  确认收货: "confirm receipt",
  订单完成: "order complete",
  待评价: "pending evaluation",
  订单取消: "order cancel",
  "确定要取消订单吗？": "Are you sure you want to cancel your order?",
  "操作成功!": "operation successful!",
  "确定要删除订单吗？": "are you sure you want to delete the order?",
  "确认收货吗？": "confirm receipt?",
  订单创建: "Order creation",
  订单支付: "Order payment",
  卖家发货: "seller shipped",
  买家确认收货: "buyer confirmation of receipt",
  "订单状态：订单取消": "order status: order cancelled",
  "您的订单已取消。": "your order has been cancelled.",
  "您的订单已提交成功！": "Your order has been submitted successfully!",
  "订单状态：待发货": "order status: pending delivery",
  "您的订单已支付成功，请等待商家发货！":
    "your order has been paid successfully, please wait for the merchant to ship your order!",
  "订单状态：待收货": "order status: pending receipt",
  "您的订单已发货，请等待商品到达！":
    "your order has been shipped, please wait for the product to arrive!",
  "订单状态：待评价": "order status: pending evaluation",
  "您的订单已签收，请评价商品！":
    "your order has been signed for, please evaluate the item!",
  商品总计: "Product total",
  优惠券: "Coupon",
  商品优惠金额: "product discount amount",
  应付金额: "Amount payable",
  联系电话: "contact phone",
  配送信息: "Delivery information",
  配送方式: "delivery method",
  到店自提: "Pick up at the store",
  线下店铺: "offline shop",
  店铺名称: "Shop name",
  店铺地址: "Shop address",
  物流配送: "Delivery",
  快递公司: "courier company",
  快递单号: "express order number",
  "订单号：": "Order number:",
  物流详情: "logistics details",
  商品评分: "product rating",
  评价晒单: "evaluation sunshine",
  "分享体验心得，给万千想买的人一个参考":
    "share the experience to give thousands of people who want to buy a reference",
  无: "None",
  提交: "Submit",
  推荐尺寸: "recommended size",
  "文件上传失败:": "file upload failed:",
  数量已超过: "the number has exceeded",
  "个！": "piece!",
  "请选择jpg,jpeg,png格式图片！": "please select jpg,jpeg,png format image!",
  "上传文件大小不能超过2MB!": "upload file size cannot exceed 2MB!",
  收货人手机号码: "recipient mobile number",
  省级地区: "provincial area",
  市级地区: "city level area",
  区级地区: "district area",
  月销: "monthly sales",
  暂无可用优惠: "No available offers at the moment",
  配送: "Delivery",
  包邮: "package",
  买家自付: "buyer pays",
  请选择规格: "Please select specifications",
  请填写完整数据: "Please fill in the complete data",
  库存不足: "out of stock",
  "超出产品库存！": "out of product stock!",
  "领取成功！": "collection success!",
  "兑换成功！": "exchange success!",
  已添加到购物车: "add cart success",
  库存: "in stock",
  优惠券详情: "coupon details",
  登录邮箱账号: "your login email account",
  邮箱格式不正确: "E-mail format is incorrect",
  请到邮箱查收: "Please check in the mailbox",
  请查收: "Please check",
  预约时间: "Appointment time",
  预约项目: "Appointment Name",
  预约日期: "Appointment date",
  预约状态: "Appointment status",
  预约地址: "Appointment address",
  服务详情: "Service details",
  该预约暂无内容数据: "There is no content data for this appointment",
  确定预约: "Confirm appointment",
  预约门店: "Appointment store",
  请选择预约到店时间: "Please choose an appointment time",
  请选择预约日期: "Please select an appointment date",
  请选择预约时间: "Please choose an appointment time",
  请选择预约门店: "Please select an appointment store",
  预约成功: "Appointment successful",
  我的预约: "My appointment",
  待确认: "to be confirmed",
  已确认: "Confirmed",
  已完成: "Completed",
  已取消: "Canceled",
  店铺: "Shop",
  预约号: "Appointment number",
  "确定要取消预约吗？": "Are you sure you want to cancel the appointment?",
  获取该预约信息失败: "Failed to get the appointment information",
  到店后请出示预约码: "Please show the reservation code when you arrive",
  发送预约码到手机: "Send appointment code to mobile phone",
  下单时间: "Order time",
  待审核: "Pending review",
  通过: "Pass through",
  不通过: "Fail",
  商城首页: "Mall Home",
  已领完: "Finished",
  选择时间: "choose time",
  标题: "title",
  当前积分: "Current points",
  累计积分: "Accumulated points",
  消费积分: "Consumption points",
  积分日志: "points log",
  日志内容: "log content",
  时间: "time",
  积分明细: "Points details",
  我的积分: "My points",
  Stripe支付: "Stripe payment",
  Paypal支付: "paypal payment",
  到店支付: "Pay at the store",
  全部清空: "Empty all",
  全部已读: "all read",
  您还没有推送消息: "You haven't pushed messages yet",
  暂未登录: "Not logged in yet",
  我的消息: "My Message",
  消息中心: "Message Center",
  已读: "Read",
  未读: "Unread",
  购物车: "Cart",
  好评: "praise",
  中评: "average",
  差评: "negative Ratings",
  有图: "pictures",
  追加: "Additional Review",
  好评率: "praise rate",
  匿名用户: "Anonymous",
  "这个人很懒，什么都没留下~": "This person is lazy and left nothing~",
  天后追加: "days append",
  当天追加: "add on the day",
  暂无评价信息: "No evaluation information",
  收货人: "receiver",
  产品分类: "Product category",
  前往结算: "Go to settlement",
  预约列表: "Appointment list",
  立即预约: "Reservation Now",
  输入并搜索: "Type and search",
  规格: "Specification",
  立即结算: "Settle now",
  继续购物: "continue shopping",
  注册协议: "Registration Agreement",
  条件和条款: "Terms and Conditions",
  兑换: "Exchange",
  已兑换: "Exchanged",
  领取: "Receive",
  已领取: "has received",
  请选择: "Please choose",
  请选择商品: "Please choose product",
  暂无相关订单: "No related orders",
  请输入收货人姓名: "Please enter the name of the consignee",
  请输入收货人手机号: "Please enter the consignee's mobile phone number",
  请选择收货地区: "Please select the delivery area",
  请输入收货地址: "Please enter the delivery address",
  消耗: "Consume",
  请输入关键字: "Please enter key words",
  预约订单详情: "Reservation order details",
  暂无相关消息: "No related news",
  我的: "Mine",
  消耗积分: "Points consumption",
  订单信息: "Order information",
  已核销: "written off",
  未核销: "not written off",
  核销码: "verification code",
  复制: "copy",
  复制成功: "Copy successfully",
  复制失败: "Copy failed",
  共为你找到: "Found for you",
  款商品: "products",
  待使用: "To be used",
  商品细节: "Product Details",
  立即付款: "Pay Now",
  设置为默认地址: "Set as Default address",
  总价: "total",
  建立帳戶: "Create Account",
  登入: "Login",
  所有商品: "All Products",
  "載入中，請稍候...": "Loading, please wait...",
  商品分類: "Category",
  查閱更多: "View More",
  商城資訊: "Mall Information",
  排序依據: "Sort By",
  "價錢（低至高）": "Price (Low to High)",
  "價錢（高至低）": "Price (High to low)",
  價錢: "Price",
  確定: "OK",
  "抱歉，找不到你所查詢的相關商品，請嘗試以其他關鍵字重新搜尋。":
    "Sorry, there are no results for your search, try a different search.",
  "系統出現錯誤。": "Unexpected system error.",
  加入購物車: "Add to Cart",
  立即購買: "Buy Now",
  商品詳情: "Product Details",
  "暫無數據顯示。": "No data to display.",
  帳戶名稱: "Username",
  記住我的密碼: "Remember Me",
  "找回密碼？": "Request New Password?",
  "忘記密碼？": "Forgot Password?",
  "登入中，請稍候...": "Login in progress, please wait...",
  "請鍵入有效的帳戶名稱或密碼。": "Please enter a valid username or password.",
  "電郵（用以登入你的商城帳戶）": "E-mail (Your login to MySmartShopping)",
  "請鍵入有效的電郵。": "Please enter a valid e-mail.",
  "手提號碼（香港）": "Mobile Number (Hong Kong)",
  驗證碼: "Verification Code",
  獲取驗證碼: "Get Verification Code",
  重新發送: "Resend",
  密碼: "Password",
  確認密碼: "Confirm Password",
  "一旦建立帳戶，就表示我已詳細閱讀及完全明白":
    "By creating an account, I confirm that I have read in detail and fully understood",
  "並同意受商城「條款及細則」之約束，":
    "and agree to be bound by MySmartShopping's Terms and Conditions",
  以及: "and",
  "同意網站可根據「私隱政策」及「收集個人資料聲明」使用於本表格上提供的個人資料。":
    "and consent to the use of the personal data provided on this form in accordance with the Privacy Policy and PICS.",
  "已擁有商城帳戶？": "Already have a Mall Account?",
  "建立帳戶中，請稍候...": "Processing, please wait...",
  請鍵入有效的密碼: "Please enter a valid password.",
  "請鍵入有效的驗證碼。": "Please enter a valid verification code.",
  "請完成驗證程序。": "Please complete the verification.",
  "密碼不相符，請重新鍵入。": "Password does not match, please re-enter.",
  "你未勾選同意受「條款及細則」之約束。":
    "Please tick I agree to the terms and conditions checkbox.",
  "歡迎！你已成功建立「商城」帳戶！立即體驗各項功能！":
    "Welcome! You have successfully registered for a Mall account. Try out our features.",
  "驗證碼已發送。": "Verification Code sent.",
  通告列表: "Announcement List",
  通告詳情: "Announcement Details",
  首頁: "Home",
  預約服務: "Appointment",
  搜尋結果: "Search Results",
  "正在搜尋，請稍候...": "Searching in progress, please wait...",
  我的優惠券: "My Coupons",
  新增送貨地址: "Add Delivery Address",
  地址: "Address",
  "電話（香港）": "Phone Number (Hong Kong)",
  預設地址: "Default Address",
  "暫無送貨地址，請新增地址。":
    "No delivery addresses avaliable, please add new address.",
  新增地址: "Add Address",
  "你目前沒有優惠券。": "You don't have any coupons in your list.",
  我的訂單: "My Orders",
  指示: "Operation",
  實付金額: "Payment Amount",
  查閱詳情: "View Details",
  "你還沒有新增任何訂單。": "You haven't created any orders.",
  "付款审核處理中，請稍候...": "Processing, please wait...",
  待送貨: "Pending for Delivery",
  待收貨: "Pending the Receipt",
  付款失敗: "Payment Failed",
  配貨: "Dispatch",
  送貨: "Delivery",
  訂單狀態: "Order Status",
  取消訂單: "Cancel Order",
  付款時間只保留: "Payment time reserved for",
  "因付款超時系統自動取消訂單。":
    "Your order canceled because your payment was not successfully completed within the expiry time.",
  已結束: "Closed",
  "訂單狀態：已付款，待审核確認": "Order Status: Paid and Pending Review",
  "訂單狀態：已關閉": "Order Status: Closed",
  "你的訂單已關閉。": "Your transaction has been closed automatically.",
  "訂單狀態：已完成": "Order Status: Completed",
  "交易成功，多謝惠顧。":
    "Your order has been successfully processed, thank you.",
  商品名稱: "Product Name",
  "應付金額：": "Amount Payable",
  "你無法查閱訂單詳情。": "You cannot view this order details.",
  取消失敗: "Cancellation Failed",
  請在: "Please",
  "24小時內": "",
  "完成付款，超時系統自動取消訂單。":
    "complete the ordering process within 24 hours. Otherwise, your order will be canceled because your payment was not successfully completed within the expiry time.",
  "常用名稱：": "Preferred Name",
  "請鍵入你的常用名稱。": "please enter your preferred name.",
  "請選擇付款金額。": "Please select the payment amount.",
  "鍵入金額：": "Enter the Amount:",
  "請鍵入你的留言。": "please enter your message.",
  付款方式: "Payment Method",
  "訂單金額：": "Order Amount:",
  "實付金額：": "Payment Amount:",
  "付款處理中，請稍候...": "Processing, please wait...",
  其他: "Other",
  付款成功: "Payment Successful",
  港幣$: "HKD$",
  查閱訂單: "View Order",
  繼續選購: "Continue Shopping",
  "聯絡人：": "Contact Person:",
  "（預設地址）": "(Default Address)",
  "送貨地址：": "Delivery Address:",
  "手提電話（香港）：": "Mobile Number (Hong Kong):",
  使用新送貨地址: "Use New Address",
  聯絡人姓名: "Contact Person Name",
  "手提電話（香港）": "Mobile Number (Hong Kong)",
  送貨地址: "Delivery Address",
  儲存: "Save",
  修改送貨地址: "Edit Delivery Address",
  "提交訂單處理中，請稍候...": "Processing the order, please wait...",
  請選擇送貨地址: "Please select a delivery address",
  偏好: "Preference",
  全選: "Select All",
  刪除已選商品: "Delete Selected",
  已選: "Selected",
  項商品: "Products",
  "付款總額（不含運費）": "Total (excluding Delivery Fee)",
  已逹最低數量: "Reached Minimum Quantity",
  "刪除失敗。": "Failed to delete.",
  "刪除成功。": "Deleted successfully.",
  送貨詳情: "Delivery Details",
  購物摘要: "Shopping Summary",
  產品總額: "Product Subtotal",
  備註: "Remarks",
  "請鍵入有效的內容。": "Please enter a valid message.",
  使用優惠券: "Use Coupon",
  應付總額: "Total",
  優惠: "Discount",
  運費: "Delivery Fee",
  可用優惠券: "Available Coupons",
  滿: "Full",
  減: "Minus",
  積分: "Points",
  無限制使用: "Unlimited Usage",
  只限商品: "Products only",
  所有商品可用: "Applicable to all products",
  只限商戶: "Shop only",
  所有商戶適用: "Applicable to all shops",
  部分商戶適用: "Applicable to selected shops",
  提交訂單: "Submit",
  "你確定要删除訂單嗎？": "Are you sure you want to delete the order?",
  已過期: "Expired",
  合計: "total",
  去購物車: "Go to Cart",
  "購物車沒有商品，請即選購心頭好。":
    "Your shopping cart is empty. Shop your favorites now.",
  登出: "Logout",
  "請鍵入有效的商品內容。": "Please enter a valid product detail.",
  評價: "Customer Review",
  訂單編號: "Order Number",
  查閱物流: "View Logistics",
  删除訂單: "Delete Order",
  批量評價: "Bulk Comments",
  確認送貨: "Confirm Delivery",
  訂單完成: "Order Completed",
  待評價: "Waiting for Comments",
  訂單取消: "Order cancelled",
  "你確定要取消訂單嗎？": "Are you sure you want to cancel your order?",
  "操作指示成功。": "Operation completed successfully.",
  "你確定要刪除訂單嗎？": "Are you sure you want to delete the order?",
  "你確定要確認送貨嗎？": "Are you sure you want to confirm receipt?",
  建立訂單: "Create Order",
  訂單付款: "Order Paid",
  賣家發貨: "Seller dispatched the order",
  買家確認送貨: "Buyer has collected the order",
  "訂單狀態：取消": "Order Status: Cancelled",
  "你的訂單已被取消。": "Your order has been cancelled.",
  "訂單狀態：待發貨": "Order Status: Awaiting to be Delivered",
  "你的訂單成功付款，請等待商家發貨。":
    "Your order has been charged successfully. The package will be delivered by the seller and please patiently wait during the order process.",
  "你的訂單成功發貨，請等待商品派送。":
    "Your order has been dispatched successfully, please patiently wait during the order process.",
  "訂單狀態：待評價": "Order Status: Waiting for Comments",
  "你的訂單成功送貨，請評價商品。":
    "Your order has been delivered successfully, please comment the item.",
  商品合共: "Total Item Amount",
  優惠券: "Coupon",
  商品優惠金額: "Product Discount Amount",
  "聯絡電話（香港）": "Contact Number (Hong Kong)",
  送貨資料: "Delivery Details",
  送貨方式: "Delivery Method",
  到店自取: "Pickup at Shop",
  線下商店: "Physical Shop",
  商店名稱: "Shop Name",
  商店地址: "Shop Address",
  速遞公司: "Express Delivery Company",
  追踪編號: "Tracking Reference Number",
  "訂單編號：": "Order Number:",
  物流詳情: "Logistics Details",
  商品評分: "Product Ratings",
  商品滿意度及評價: "Product Reviews and Ratings",
  暫無: "None",
  圖片建議尺寸: "Suggested image size",
  上傳圖片檔案失敗: "File upload failed",
  "圖片檔案數量超出限制。": "Image file quantities exceed limits.",
  圖片: "images",
  "請選擇JPG、JPEG或PNG圖片檔案格式。":
    "Please select JPG, JPEG or PNG image file format.",
  "圖片檔案大小上限不能超過2MB。": "Each image file cannot exceed 2 MB.",
  "收貨人手提號碼（香港）": "Recipient's Mobile Number (Hong Kong)",
  省: "Province",
  市: "City",
  地區: "District",
  每月銷售額: "Monthly Sales",
  "暫無優惠券。": "No coupons available.",
  包郵: "Free Delivery",
  貨到付款: "Paid by Buyer",
  請選擇規格: "Please select specification",
  商品缺貨: "Out of Stock",
  領取成功: "Redeemed Successfully",
  兌換成功: "Exchanged Successfully",
  成功加到購物車: "Added to Cart",
  商品庫存: "Product In-stock",
  優惠券詳情: "Coupon Details",
  "請鍵入電郵。": "Please enter email.",
  "請到電郵查閱。": "Please check your email.",
  請查閱: "Please check",
  預約時間: "Appointment Time",
  預約日期: "Appointment Date",
  預約狀態: "Appointment Status",
  預約地址: "Appointment Address",
  預約詳情: "Appointment Details",
  確認預約: "Confirmed Appointment",
  "請選擇預約到店日期、時間及商店":
    "Please select an appointment date and time, and shop",
  請選擇預約日期: "Please select an appointment date",
  請選擇預約時間: "Please select an appointment time",
  請選擇預約商店: "Please select a shop",
  "預約成功。": "Appointment made successfully.",
  我的預約: "My Appointment",
  待確認: "To be Confirmed",
  已確認: "Confirmed",
  商店: "Shop",
  預約編號: "Reservation Number",
  "你確定要取消預約嗎？": "Are you sure you want to cancel the appointment?",
  獲取此預約訊息失敗: "Failed to get the appointment information",
  "到店後請出示預約碼（QR Code）":
    "Please show the reservation code (QR Code) when you arrive",
  發送預約碼到手提號碼: "Send reservation code to mobile phone",
  "建立日期／時間": "Creation Date/Time",
  待審核: "Waiting for Approval",
  通過: "Approved",
  不通過: "Not Approved",
  換領結束: "Redemption Ended",
  選擇時間: "Select Time",
  標題: "Title",
  目前積分: "Current Reward Points",
  累計積分: "Progressive Reward Points",
  累計消費: "Progressive Sales",
  積分記錄: "Reward Points Record",
  消費記錄: "Sales Record",
  "日期／時間": "Date/Time",
  積分內容: "Reward Points Details",
  積分中心: "Reward Points Center",
  "Stripe 付款": "Stripe Payment",
  "Paypal 付款": "Paypal Payment",
  到店付款: "Pay at Shop",
  全部清除: "Clear All",
  全部已讀: "Read All",
  "你還没有送出訊息。": "You haven't sent messages yet.",
  暫未登入: "Haven't logged in yet",
  已讀: "Read",
  未讀: "Unread",
  購物車: "Shopping Cart",
  好評: "Good",
  中評: "Average",
  劣評: "Poor",
  有圖: "With Picture",
  好評率: "Good Rating",
  "暫無商品評論，請即選寫你的評價。":
    "No product reviews, please begin your comments here.",
  之後追加: "Additional Review (After)",
  當天追加: "Additional Review (Same Day)",
  暫無相關評論: "No product reviews",
  收貨人: "Recipient",
  預約列表: "Appointment List",
  新增預約: "Add Appointment",
  "站內搜尋...": "Type to search...",
  規格: "Specification",
  繼續購物: "Continue Shopping",
  註冊協議: "Registration Agreement",
  兌換: "Exchange",
  領取: "Redeem",
  已領取: "Redeemed",
  請選擇: "Please select",
  "請鍵入有效的收貨人姓名。": "Please enter a valid Recipient's name.",
  "請鍵入有效的手提號碼（香港）。":
    "Please enter a valid mobile phone number (Hong Kong).",
  "請選擇送貨地區。": "Please select the delivery area.",
  "請鍵入有效的地址。": "Please enter a valid address.",
  "請鍵入搜尋關鍵字。": "Please enter keywords to search.",
  預約訂單詳情: "Reservation Details",
  我的帳戶: "My Account",
  使用積分: "Bonus Points Used",
  訂單詳情: "Order Details",
  已核銷: "Verified",
  未核銷: "Not Verified",
  核銷編號: "Verification Number",
  複製: "Copy",
  複製成功: "Copied successfully",
  複製失敗: "Failed to Copy",
  共為你找到: "Total",
  預設送貨地址: "Default Delivery Address",
  付款總額: "Total",
  资讯分享: "Blog",
  名称: "name",
  请输入您的邮箱: "Please input your email",
  请输入您的手机号码: "Please input your phone number",
  消息: "information",
  发送成功: "Sent successfully",
  发送消息: "Send Information",
  联系我们: "Call us",
  分享: "Share",
  上传凭证: "Upload vouchers",
  已上传凭证: "Uploaded voucher",
  暂未上传凭证: "No credentials have been uploaded yet",
  创建成功: "Create Success",
  "提示：积分可以用来兑换指定商品":
    "Reminder: Points can be used to redeem specified products",
  分值明细: "Score Details",
  可约: "reducible",
  约满: "about full",
  请输入评价: "Please enter a review",
  Fps支付: "FPS Pay",
  PayMe支付: "PayMe Pay",
  香港特別行政區: "Hong Kong Special Administrative Region",
  香港島: "Hong Kong Island",
  九龍: "Kowloon",
  新界: "the New Territories",
  中西區: "Central and Western Regions",
  灣仔: "Wan Chai",
  東區: "Eastern District",
  南區: "southern district",
  九龍城區: "Kowloon City Area",
  油尖旺區: "Yau Tsim Mong District",
  深水埗區: "Sham Shui Po District",
  黃大仙區: "Wong Tai Sin District",
  觀塘區: "Kwun Tong District",
  北區: "Northern District",
  大埔區: "Dapu District",
  沙田區: "Sha Tin District",
  西貢區: "Saigon District",
  元朗區: "Yuen Long District",
  屯門區: "Tuen Mun District",
  荃灣區: "Tsuen Wan District",
  葵青區: "Kuiqing District",
  離島區: "islands",
  返回購物車: "Return to cart",
  快遞費: "Shopping Cost",

  Min: "Min",
  Max: "Max",
  Filter: "Filter",

  Information: "Information",
  FollowUsOn: "Follow Us On",

  SendMessage: "Send Message",
};
